module.exports = __webpack_public_path__ + "img/jcb@2x.4f218a3c.png";